__turbopack_context__.v({
  "bottomNote": "DeliveryInfoItem-module-scss-module__bUAQ7W__bottomNote",
  "dayNote": "DeliveryInfoItem-module-scss-module__bUAQ7W__dayNote",
  "dayTitle": "DeliveryInfoItem-module-scss-module__bUAQ7W__dayTitle",
  "deliveryInfoDay": "DeliveryInfoItem-module-scss-module__bUAQ7W__deliveryInfoDay",
  "deliveryInfoItem": "DeliveryInfoItem-module-scss-module__bUAQ7W__deliveryInfoItem",
  "description": "DeliveryInfoItem-module-scss-module__bUAQ7W__description",
  "item": "DeliveryInfoItem-module-scss-module__bUAQ7W__item",
  "list": "DeliveryInfoItem-module-scss-module__bUAQ7W__list",
  "list_number": "DeliveryInfoItem-module-scss-module__bUAQ7W__list_number",
  "notation": "DeliveryInfoItem-module-scss-module__bUAQ7W__notation",
  "note": "DeliveryInfoItem-module-scss-module__bUAQ7W__note",
  "timeWork": "DeliveryInfoItem-module-scss-module__bUAQ7W__timeWork",
  "title": "DeliveryInfoItem-module-scss-module__bUAQ7W__title",
});
